<script lang="ts">
  import Button from '$components/ui/button.svelte';
  import SplitLines from './split-lines.svelte';
  import { cn } from '$lib/utils';
  import { getAnchorFromCmsLink } from '$lib/utils/cms';
  import type { InfoStoryblok } from '$types/bloks';

  export let block: InfoStoryblok;
  let className: string | undefined = undefined;
  export { className as class };

  const ctaVariant = block.cta_variant || 'accent';
</script>

<div>
  <div class={cn('flex flex-col gap-2', className)}>
    <p class="text-3xl font-semibold">{block.title}</p>
    {#if block.text}
      <SplitLines class="text-xl text-primary/80" text={block.text} />
    {/if}
  </div>
  {#if block.cta_link && block.cta_label}
    <Button
      name={block.cta_label}
      as="a"
      variant={ctaVariant}
      href={$getAnchorFromCmsLink(block.cta_link).href}
      class="mt-5">{block.cta_label}</Button
    >
  {/if}
</div>
